export default "__VITE_ASSET__0f7486b4__"